import classNames from 'classnames';
import React from 'react';

interface BackgroundImageProps {
  url?: string;
  alt?: string;
  className?: string;
  regularImage?: boolean;
  onClick?: () => void;
  viewportSize?: {
    desktop?: number;
    desktopSmall?: number;
    tablet?: number;
    mobile?: number;
  };
}

const OptimizedImage: React.FC<BackgroundImageProps> = ({
  url,
  alt = '',
  regularImage,
  className,
  onClick,
  viewportSize = {
    desktop: 100,
    desktopSmall: 100,
    tablet: 100,
    mobile: 100,
  },
}) => {
  const size = {
    desktop: (1920 / 100) * (viewportSize.desktop || 100),
    desktopSmall: (1440 / 100) * (viewportSize.desktopSmall || 100),
    tablet: (1024 / 100) * (viewportSize.tablet || 100),
    mobile: (768 / 100) * (viewportSize.mobile || 100),
  };

  if (!url) {
    return null;
  }

  const getSrc = (width: number) => {
    const isShopifyImage = url.includes('cdn.shopify.com');
    const paramJoiner = isShopifyImage ? '&' : '?';
    let imageQualityParam = `&quality=${process.env.REACT_APP_IMAGE_QUAILITY || 80}`;
    if (isShopifyImage) {
      imageQualityParam = '';
    }

    return `${url}${paramJoiner}width=${Math.ceil(width)}&format=webp${imageQualityParam}`;
  };

  return (
    <div
      className={classNames(
        'bi',
        {
          regular: regularImage,
        },
        className
      )}
      onClick={() => !!onClick && onClick()}
    >
      <picture>
        <source media="(min-width: 1440px)" srcSet={getSrc(size.desktop)} type="image/webp" />
        <source media="(min-width: 1024px)" srcSet={getSrc(size.desktopSmall)} type="image/webp" />
        <source media="(min-width: 768px)" srcSet={getSrc(size.tablet)} type="image/webp" />
        <img className="bi-image" srcSet={getSrc(size.mobile)} alt={alt} />
      </picture>
    </div>
  );
};

export default OptimizedImage;
